import axios from './request';

// 新版 - 获取用户信息
export function getUserInfo(params) {
  return axios.request({
    proxyName: "domain-user",
    url: '/company/user/info',
    method: 'get',
    params
  })
}

// 新版 - 验证账户首次登录是否需要修改密码
export function userFirstLogin(params) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/password/status',
    method: 'GET',
    params
  })
}

// 新版 - 修改用户密码
export function updateUserPassword(data){
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/update/password',
    method: 'post',
    data
  })
}

//新版 - 获取账号信息所属组织
export function getCompaniesInfo(params){
  return axios.request({
    proxyName: 'dom-relationship',
    url: '/companies/info',
    method: 'get',
    params
  })
}


// 富文本提交
export function refer(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/updete/editor/uploadFile',
    method: 'POST',
    data
  });
}

// 富文本获取内容
export function readJsonFile(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/updete/editor/readJsonFile',
    method: 'GET',
    data
  });
}

export function getPurchasers(params) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/purchasers/purchasers/' + params.id + '?refs=' + params.refs[0] + '&refs=' + params.refs[1] + '&refs=' +
      params.refs[2],
    method: 'GET'
    // params
  });
}
export function savePurchaser(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/purchasers/purchaser/savePurchaser',
    method: 'post',
    data
  });
}

// 供应商新增
export function addSupplier(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/supplier/addSupplier',
    method: 'POST',
    data
  });
}

// 供应商编辑
export function editSupplier(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/supplier/editSupplier',
    method: 'POST',
    data
  });
}

// 重置
export function resetPassword(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/resetPassword',
    method: 'POST',
    data
  });
}
// 编码
export function getSupplierCode(params) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/supplier/getSupplierCode',
    method: 'GET',
    params
  });
}

// 详情
export function getSdetali(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: +data + '?' + 'refs=company' + '&refs=supplierBankAccount' + '&refs=supplierBankAccount' +
      '&refs=supplierContractData',
    method: 'GET'
  });
}

export function find(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/ecommerce/find',
    method: 'GET'
  });
}


//  添加商品
export function getCategory(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/supplier/goodsManage/getCategory',
    method: 'GET',
    data
  });
}
export function uploadFile(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/supplier/file/uploadFile',
    method: 'POST',
    data,
    timeout: 300000
  });
}
export function addGoods1(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsManage/addGoods',
    method: 'POST',
    data
  });
}

export function editGoods(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsManage/editGoods',
    method: 'POST',
    data
  });
}

// 供应商--添加品牌
export function addBrand(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsBrand/addBrand',
    method: 'POST',
    data
  });
}

// 供应商--添加品牌图片
export function uploadBrandImage(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/file/uploadFile',
    method: 'POST',
    data
  });
}

// 供应商--查询品牌
export function getBrandsList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsBrand/brandsList',
    method: 'GET',
    params
  });
}

// 供应商--查询品牌分页
export function getPagination(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsBrand/brandsList',
    method: 'GET',
    params
  });
}

// 供应商--列表品牌编辑1
export function getFindBrand(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: '/supplier/goodsBrand/findBrand/' + data.brandId,
    method: 'GET',
    data
  });
}

// 供应商--列表品牌编辑2
export function getEditBrand(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsBrand/editBrand',
    method: 'POST',
    data
  });
}

// 供应商--列表品牌删除
export function delBrand(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsBrand/delBrand/' + data.brandId,
    method: 'POST',
    data
  });
}

// 商品维护查询商品列表
export function goodsList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsManage/goodsList',
    method: 'post',
    data
  });
}

// 规格模板列表
export function specTemplateList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/specTemplateList',
    method: 'get',
    params
  });
}

// 属性模板列表
export function attrTemplateList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/attrTemplateList',
    method: 'get',
    params
  });
}

// 添加规格模板
export function addSpecTemplate(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/addSpecTemplate',
    method: 'post',
    data
  });
}

// 供应商--规格模板管理【添加属性模板】
export function addAttrTemplate(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/addAttrTemplate',
    method: 'POST',
    data
  });
}

// 供应商--规格模板管理【添加属性模板】
export function delTemplateSpec(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/specificationsTemplate/delTemplateSpec/${data.templateSpecId}`,
    method: 'POST'
  });
}

// 供应商--编辑规格属性模板列表
export function findTemplateId(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/specificationsTemplate/find/${data.templateId}`,
    method: 'get'
  });
}

// 修改属性模板
export function updateAttrTemplate(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/updateAttrTemplate',
    method: 'POST',
    data
  });
}

// 修改规格模板
export function updateSpecTemplate(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/updateSpecTemplate',
    method: 'POST',
    data
  });
}

//批量删除模板
export function batchDelTemplateSpec(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/specificationsTemplate/batchDelTemplateSpec',
    method: 'post',
    data
  });
}

//供应商--获取sku列表
export function getSkuList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsSku/skuList?page=` + data.page + `&size=` + data.size,
    method: 'post',
    data
  });
}

// 查询后台分类
export function queryList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/common/backCategory/list',
    method: 'get',
    params
  });
}

//供应商--获取sku列表
export function searchSkuList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsSku/skuList',
    method: 'post',
    data
  });
}
// ​/supplier​/goodsManage​/supply​/scope
//供应商--通用后台分类列表
export function getBackClassifyList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/supply/scope`,
    method: 'GET',
    params
  });
}

// SKU批量上架
export function batchShelves(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsSku/batchShelves',
    method: 'post',
    data
  });
}

//SKU批量下架
export function batchTakeDown(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsSku/batchTakeDown',
    method: 'post',
    data
  });
}

// 上下架单个SKU
export function modifySkuStatus(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsSku/modifySkuStatus',
    method: 'post',
    data
  });
}

// 删除单个SKU
export function delSku(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsSku/delSku/${data.skuId}`,
    method: 'post'
  });
}

// 修改SKU
export function editSku(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsSku/skuConfig',
    method: 'post',
    data
  });
}

// 查询审核商品列表
export function auditGoodsList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsAudit/auditGoodsList?page=` + data.page + `&size=` + data.size,
    method: 'post',
    data
  });
}
// 查询审核商品列表
export function queryGoodsList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsAudit/auditGoodsList',
    method: 'post',
    data
  });
}
// 根据商品spuID查询审核商品详情
export function findAuditGoods(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsAudit/findAuditGoods/${params.spuId}`,
    method: 'GET'
  });
}
// 商品审核重新申请
export function submitApply(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsAudit/submitApply',
    method: 'post',
    data
  });
}
// 商品审核撤销申请
export function cancelApply(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsAudit/cancelApply',
    method: 'post',
    data
  });
}

// 商品维护查询商品详情
export function goodsDetail(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/goods/${params.spuId}`,
    method: 'GET'
  });
}

// 商品维护查询物流方案
export function goodsLogistics(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsLogistics/plans`,
    method: 'GET',
    params
  });
}

// 商品维护批量发布
export function batchPublish(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/batchPublish`,
    method: 'POST',
    data
  });
}

// 商品维护批量取消发布
export function batchCancelPublish(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/batchCancelPublish`,
    method: 'POST',
    data
  });
}

// 商品维护删除商品
export function delGoods(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/delGoods/${data.spuId}`,
    method: 'POST'
  });
}
// 商品维护批量删除商品
export function batchDelGoods(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/batchDelGoods`,
    method: 'POST',
    data
  });
}

// 商品维护查询草稿列表
export function draftGoodsList(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/draftGoodsList?page=` + data.page + `&size=` + data.size,
    method: 'POST',
    data
  });
}

// 查询草稿列表
export function queryDraftGoodsList(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/draftGoodsList`,
    method: 'POST',
    data
  });
}

// 商品维护查询商品列表
export function goodsListPagination(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/goodsList?page=` + data.page + `&size=` + data.size,
    method: 'post',
    data,
    flag: true
  });
}

// 供应商--查询品牌不带分页
export function findBrandsList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/goodsManage/brand/list',
    method: 'GET',
    params
  });
}

// 商品维护弹窗规格属性
export function goodsTemplate(params) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: `/supplier/specificationsTemplate/find/template`,
    method: 'GET',
    params
  });
}

// 运费模式查询
export function queryFreight(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/freight/mode/query/type',
    method: 'GET',
    params
  });
}

// 运费修改模式
export function modifyFreight(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/mode/update/type`,
    method: 'post',
    data
  });
}

// 订单运费列表
export function freightList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/freight/order/template/list',
    method: 'GET',
    params
  });
}

// 订单模板删除
export function delOrderFreight(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/order/template/del/${data.templateId}`,
    method: 'post',
    data
  });
}

// 查询订单模板详情
export function freightFindGood(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/order/template/find/${params.templateId}`,
    method: 'GET'
  });
}

// 单品运费列表
export function freightGoodList(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/freight/good/template/list',
    method: 'GET',
    params
  });
}

// 运费查询地址
export function address(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/address/two/level/address',
    method: 'GET',
    params
  });
}

// 运费禁止选中地址
export function area(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/freight/order/template/find/user/area',
    method: 'GET',
    params
  });
}

//新增订单运费模板
export function addOrderFreight(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/order/template/add`,
    method: 'post',
    data
  });
}

// 单品模板删除
export function delFreight(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/good/template/del/${data.templateId}`,
    method: 'post',
    data
  });
}

// 查询单品模板详情
export function findProduct(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/good/template/find/${params.templateId}`,
    method: 'GET',
    params
  });
}

// 编辑订单运费模板
export function modifyOrderFreight(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/order/template/modify`,
    method: 'post',
    data
  });
}

// 供应商 订单列表
export function orderList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/order/list',
    method: 'post',
    data
  });
}

// ​/supplier​/order​/export​/order
// 供应商端订单导出
export function orderExport(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/order/export/order',
    method: 'post',
    data
  })
}
// /supplier/order/get/download
// 获取任务状态 及下载地址
export function exportDownload(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/order/get/download',
    method: 'get',
    params
  })
}
// ​/association​/getPartnerInfo
// 模糊匹配伙伴名称
export function getPartnerInfo(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/association/getPartnerInfo',
    method: 'get',
    params
  });
}
// 供应商 订单详情
export function orderDetail(orderId) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/order/detail/${orderId}`,
    method: 'post'
  });
}

//供应商 订单处理列表
export function orderProcessingList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/Performance/order/list`,
    method: 'post',
    data
  });
}
//供应商 订单处理详情
// /supplier​/Performance​/order​/detail​/
export function orderProcessingDetailed(orderId) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/Performance/order/detail/${orderId}`,
    method: 'post'
  });
}
// 订单生成
// /supplier/Performance/order/upload/excel
export function orderUploadExcel() {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/Performance/order/upload/excel`,
    method: 'post'
  });
}
// 订单导出
// /supplier/Performance/order/export/excel
export function orderOutExcel(data) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: `/supplier/Performance/order/export/excel`,
    method: 'post',
    data
  });
}
//供应商 订单确认发货
export function orderProcessingSuccess(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/Performance/order/confirm/deliver`,
    method: 'post',
    data
  });
}
//供应商 创建订单缺货
export function createdStockoutOrder(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/stockoutOrder/saveStockoutOrder`,
    method: 'post',
    data
  });
}
//供应商 缺货分页查询
export function queryStockoutOrder(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/stockoutOrder/queryStockoutOrder`,
    method: 'post',
    data
  });
}
//供应商 查询缺货单详情
export function queryStockoutOrderSku(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/stockoutOrder/queryStockoutOrderSku`,
    method: 'get',
    params
  });
}
// ​/supplier​/deliver​/order​/list
// 发货单列表
export function orderSendOutList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/deliver/order/list',
    method: 'post',
    data
  });
}

// /supplier/deliver/order/detail
// 供应商发货单详情
export function orderSendOutDetailed(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/deliver/order/detail`,
    method: 'get',
    params
  });
}
// 供应商发货订单详情sku分页列表
export function orderSendOutDetailedSkuList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/deliver/order/detail/sku/list`,
    method: 'post',
    data
  });
}
//--售后管理
// 售后列表
// /supplier/aftersale/order/list
export function afterList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/order/list',
    method: 'post',
    data
  });
}
// 新增物流信息
// /supplier/aftersale/logistics/add/deliver/logistics
export function addLogistics(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/logistics/add/deliver/logistics',
    method: 'post',
    data
  });
}
// 查询物流公司
// /supplier/aftersale/logistics/company/list
export function searchLogisticsInfo(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/logistics/company/list',
    method: 'get',
    params
  });
}
//--售后详情
// /supplier/aftersale/order/find
export function afterDetail(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/order/find',
    method: 'get',
    params
  });
}
//行为日志
// /supplier/aftersale/operationLog/list
export function operationLog(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/operationLog/list',
    method: 'get',
    params
  });
}
// 退款详情
// ​/supplier​/aftersale​/refundOrder​/detail
export function aRefundDetail(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/refundOrder/detail',
    method: 'post',
    data
  });
}
// 完成售后单
// /supplier/aftersale/order/success/order
export function successOrder(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/order/success/order',
    method: 'post',
    data
  });
}

//--地址管理
// ​/supplier​/aftersale​/address​/add
// 添加退货地址
export function addreeAdd(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/address/add',
    method: 'post',
    data
  });
}
// 编辑退货地址
export function editAddress(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/address/edit',
    method: 'post',
    data
  });
}
// 根据父地址ID查询列表，不传默认查询顶级列表
export function getNextAddress(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/address/next/address',
    method: 'get',
    params
  });
}
// 删除退货地址
export function delAddress(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/aftersale/address/del/${data}`,
    method: 'post'
  });
}
// 查询退货地址列表
export function addressList(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/aftersale/address/list',
    method: 'post',
    data
  });
}
// 设为默认地址
export function defaultAddress(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/aftersale/address/set/default/${data}`,
    method: 'post'
  });
}

// 查询不可配置地址
export function prohibitAddress(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/good/template/find/area`,
    method: 'GET',
    params
  });
}

// 新增单品运费模板
export function addTemplate(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/good/template/add`,
    method: 'post',
    data
  });
}

// 修改单品运费模板
export function modifyTemplate(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/good/template/modify`,
    method: 'post',
    data
  });
}

// 查看模板详情
export function freightLooks(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/freight/good/template/find/${params.templateId}`,
    method: 'GET',
    params
  });
}
//公告
export function noticeList(params) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: `/supplier/notice/list`,
    method: 'GET',
    params
  });
}

export function noticedetel(params) {
  return axios.request({
    flag: true,
    proxyName: 'bff-supplier',
    url: `/supplier/notice/notice/` + params,
    method: 'GET'
  });
}





// 首页数据
export function homeData(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/home/data',
    method: 'GET',
    params
  });
}

// 根据模板获取规格和属性
export function specificationsTemplate(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/specificationsTemplate/find/${params.templateId}`,
    method: 'GET'
  });
}


// 获取商品批量导入进度
export function getCommodityWorker(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/scheduleList`,
    method: 'GET',
    params
  });
}

// 获取商品模板excel
export function getGoodsTemplate(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/download/sample-template`,
    method: 'GET',
    params
  });
}

// 商品批量导入确认按钮
export function goodsImportConfirm(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/import/confirm`,
    method: 'POST',
    data
  });
}
// 获取发票抬头列表
export function invoiceHeaderList(data) {
  return axios.request({
    proxyName: 'bff-purchaser',
    url: '/invoiceHeaders',
    method: 'GET',
    data
  });
}
// 获取类目属性
export function categoryThreeId(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/common/category-param/cat-three-id',
    method: 'GET',
    params
  });
}
// 判断类目是否存在
export function backendCheck(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/common/category/backend/check',
    method: 'GET',
    params
  });
}


//批量筛选取消发布商品
export function batchSearchCancelPublish(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/async/batchSearchCancelPublish',
    method: 'POST',
    data: data
  });
}
//批量筛选发布商品
export function batchSearchPublish(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/async/batchSearchPublish',
    method: 'POST',
    data: data
  });
}
//查询任务进度
export function queryTaskProgress(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/async/queue',
    method: 'GET',
    params
  })
}
// 商品管理复制商品数据
export function goodsCopyDetail(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: `/supplier/goodsManage/goods/copy/${params.spuId}`,
    method: 'GET'
  });
}
/* 批量更新库存查询接口 */
export function queryUpdateStock(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/stock/queryUpdateStockCache',
    method: 'POST',
    data: data
  });
}
// 批量提交库存修改
export function updateStock(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/stock/updateStockCache',
    method: 'POST',
    data: data
  });
}

// 登录
export function login(auth, data) {
  return axios.request({
    proxyName: "comm-auth",
    url: '/token/create',
    method: 'post',
    auth: auth,
    data: data,
    headers:{"Login-Type":data.loginType},
    flag: true
  })
}

// 退出登录
export function logout(auth, data) {
  return axios.request({
    proxyName: "comm-auth",
    url: '/token/logout',
    method: 'post',
    flag: true
  })
}

// 用户管理
// 查询用户列表
export function getUserList(data) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/list',
    method: 'post',
    data
  });
}

// 编辑用户
export function setUserUpdate(data) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/update',
    method: 'post',
    data
  });
}


// 批量启用/停用  用户
export function setBatchEnable(data) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/batch/enable/user',
    method: 'post',
    data
  });
}

/*
 *@description:'创建用户'
*/
export function setUserCreate(data) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/create',
    method: 'post',
    data
  });
}

// 重置用户密码
export function resetUserPassword(data) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/reset/childUser/password',
    method: 'post',
    data
  });
}

/*
 *@description:'登录账号重复校验'
*/
export function checkUserName(params) {
  return axios.request({
    proxyName: 'domain-user',
    url: '/company/user/checkUsername',
    method: 'get',
    params
  });
}

// 获取权限
export function getPermission(params) {
  return axios.request({
    proxyName: "domain-permission",
    url: '/api/userAuthority/queryUserMenu',
    method: 'get',
    params
  })
}

//发货单修改物流
export function modifyLogistics(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/deliver/order/modifyLogistics',
    method: 'POST',
    data: data
  });
}

//查询物流公司列表
export function getLogisticsCom(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/deliver/order/getLogisticsCom',
    method: 'GET',
    params
  })
}


//发货excel 批量导入接口
export function setDeliverGoodsExcel(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/deliver/order/import/excel',
    method: 'post',
    data
  })
}
// 发货excel 批量导入确认
export function setDeliverGoodsConfirm(data) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/deliver/order/import/confirm',
    method: 'post',
    data
  })
}


//批量发货查询进度列表
export function getDeliverGoodsProgress(params) {
  return axios.request({
    proxyName: 'bff-supplier',
    url: '/supplier/deliver/order/import/progress',
    method: 'get',
    params
  })
}

// 查询商城列表 不分页
export function queryMallList() {
  return axios.request({
    proxyName: 'dom-cms',
    url: '/mall/queryMallListBySupplier',
    method: 'get'
  });
}
// 查询商城装修数据
export function getOwnDecorationStyle() {
  return axios.request({
    proxyName: 'dom-relationship',
    url: '/partner/getOwnDecorationStyle',
    method: 'get'
  });
}
// 查询租户角色列表
export function queryRoleList(params) {
  return axios.request({
    proxyName: 'domain-permission',
    url: '/api/sys/role/queryTenantRoleList',
    method: 'POST',
    data: params
  });
}